import PropTypes from 'prop-types';

/**
 * This is an high order of component for creating a component which only renders its children without a wrapper / container
 * for them
 * @param {String} name [''] - the display name of the component
 * @param {Object} propTypes [{}] - extending components PropTypes
 * @returns {component}
 * @constructor
 */
const NodeChildrenOnly = (name = '', propTypes = {}) => {
  const component = props => {
    return props.children;
  };

  component.propTypes = {
    ...propTypes,
    /**
     * The children this component renders
     */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  };

  component.displayName = name;

  return component;
};

export default NodeChildrenOnly;
